import { render, staticRenderFns } from "./ArticleInfoTags.vue?vue&type=template&id=84552e5c"
import script from "./ArticleInfoTags.vue?vue&type=script&lang=ts"
export * from "./ArticleInfoTags.vue?vue&type=script&lang=ts"
import style0 from "./ArticleInfoTags.vue?vue&type=style&index=0&id=84552e5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports